import axios from "axios";

class CdnInvalidator {
  createInvalidation (paths) {
    return axios.post("api/Cdn/Invalidate", paths);
  }

  // Products
  onProductDeleteOrUpdate (product) {
    const paths = [
      '/',
      '/products',
      '/products?*',
      `/products/${product.UrlTag}*`
    ];
    return this.createInvalidation(paths);
  }

  onProductCreate () {
    const paths = [
      '/',
      '/products',
      '/products?*'
    ];
    return this.createInvalidation(paths);
  }

  onProductsRearranged () {
    const paths = [
      '/',
      '/products',
      '/products?*'
    ];
    return this.createInvalidation(paths);
  }

  // Blogs
  onBlogDeleteOrUpdate (blog) {
    const paths = [
      '/blog',
      `/blog/${blog.UrlTag}*`
    ];
    return this.createInvalidation(paths);
  }

  onBlogCreate () {
    const paths = [
      '/blog',
      '/blog?*'
    ];
    return this.createInvalidation(paths);
  }

  onBlogsRearranged () {
    const paths = [
      '/blog',
      '/blog?*'
    ];
    return this.createInvalidation(paths);
  }
}
export default new CdnInvalidator();
